import React, { useRef, useEffect } from 'react';

export function VideoOnboarding({ show, onComplete, onVideoComplete, videoUrl }) {
    const videoRef = useRef(null);
    
    useEffect(() => {
        if (show && videoRef.current) {
            videoRef.current.play();
        }
    }, [show]);
    
    const handleVideoEnd = () => {
        if (onVideoComplete) {
            onVideoComplete(); // Move to interactive tutorial
        } else {
            onComplete(); // Skip directly to game
        }
    };
    
    const handleSkip = () => {
        if (onVideoComplete) {
            onVideoComplete(); // Skip to interactive tutorial
        } else {
            onComplete(); // Skip to game
        }
    };
    
    if (!show) return null;
    
    return (
        <div className="video-onboarding-overlay">
            <div className="video-onboarding-container">
                <video
                    ref={videoRef}
                    className="onboarding-video"
                    onEnded={handleVideoEnd}
                    controls={false}
                    playsInline
                >
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                
                <button 
                    className="video-skip-button"
                    onClick={handleSkip}
                >
                    Skip →
                </button>
            </div>
        </div>
    );
}
